'use client'
import React, { useEffect, useState } from 'react';
import CoverPlaceholderSection from '@/app/courses/components/sections/cover.placeholder.section';

const VideoSection = ({url}: {url: string}) => {

  const [isSSR, setIsSSR] = useState(true);

  useEffect(() => {
    setIsSSR(false);
  }, []);

  return (
    isSSR ? (
      <CoverPlaceholderSection />
    ) : (
      <video
        controls
        width={0}
        height={0}
        className="aspect-video max-h-96 object-cover "
        style={{ width: '100%', height: 'auto' }}
      >
        <source src={url} type="video/mp4" />
      </video>
    )
  );
};

export default VideoSection;
